import React, {FunctionComponent } from 'react';

import { useNavigate } from 'react-router-dom';
import {Page, route} from 'b302-frontend-library';

import Card from '../../layout/Card';
import HanButton from '../../utils/HanButton';

import Image from '../../../assets/images/universities/foto_placeholder_budapest.jpg';
import { ReactComponent as ArrowRight } from '../../../assets/icons/icon_arrow_right.svg';

interface CardData {
    title: string;
    text: string;
    url: string;
}

interface Props {}

const Dashboard: FunctionComponent<Props> = () => {
    const navigate = useNavigate();

    const cards: CardData[] = [
        {
            title: 'Universities',
            text: 'Overview of all universities visited by students.',
            url: route('admin-universities')
        },
        {
            title: 'Countries',
            text: 'Overview of all countries where universities are established.',
            url: route('admin-countries')
        },
        {
            title: 'Whitelist',
            text: 'List of email addresses that have admin access.',
            url: route('admin-whitelist')
        },
        {
            title: 'Subject Areas',
            text: 'Overview of all subject areas that students can study at universities.',
            url: route('admin-subject-areas')
        },
    ];

    return (
        <Page className={'admin-dashboard-page'}>
            <h1 className={'admin-dashboard-page__main-title'}>Dashboard</h1>

            <div className={'admin-dashboard-page__cards'}>
                { cards.map((card, i) => (
                    <Card className={'admin-dashboard-page__card'} key={i}>
                        <img className={'admin-dashboard-page__image'} src={Image} alt={'University'}/>

                        <div className={'admin-dashboard-page__card-content'}>
                            <span className={'admin-dashboard-page__title'}>{ card.title }</span>
                            <span className={'admin-dashboard-page__text'}>{ card.text }</span>

                            <HanButton onClick={() => navigate(card.url)}>
                                Go to page <ArrowRight className={'admin-dashboard-page__icon'} />
                            </HanButton>
                        </div>
                    </Card>
                )) }
            </div>
        </Page>
    );
};

export default Dashboard;
